import React from 'react'
import * as bs4 from 'reactstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import Select from 'react-select';
import { Scrollbars } from 'react-custom-scrollbars';
import Navbar from '../Navbar'
import { ScaleLoader } from 'react-spinners';
import ReactGA from 'react-ga';
const { proxy } = require('../../ip_api.config')

class Flim_CreateBomVer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            optionItem: '',
            arr_temp_item: [],
            arr_save: [],
            arr_saveBomLine: [],
            arrID: [],
            showItem: '',
            Item: '',
            Name: ''
        }
    }

    componentDidMount() {
        ReactGA.initialize('UA-176717650-5');
        ReactGA.pageview('/flim/CreateBomVer');

        if (localStorage.getItem("ID_User") !== null) {
            this.getOption()
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    getOption = async () => {
        this.setState({ isLoading: true })
        let option_size = await this.get_option_size()
        let option_type = await this.get_option_type()
        let option_color = await this.get_option_color()
        let option_roll = await this.getOption_roll()
        let getSelectItem = await this.getSelectItem()

        // console.log("get_option_itemG3", option_itemG3)
        this.setState({
            option_size: option_size,
            option_color: option_color,
            option_type: option_type,
            option_roll: option_roll,
            isLoading: false,
        }, () => { this.getItem() })
    }

    getOption_roll = async () => new Promise((resolve, reject) => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        let arroption_roll = []
        let dataWhere = {
            roll: '',
        }
        let url = proxy.server + '/flim/getMaster_Datamin'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                if (responseJson.result.lenght !== 0) {
                    responseJson.result.map(function (val, i) {
                        arroption_roll.push(
                            { value: val.slit, label: val.slit }
                        )
                    }, this)
                    resolve(arroption_roll)
                } else {
                    resolve(0)
                }
            })
    })

    get_option_size = async () => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/bom_option_size'
        let arr = []
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify()
        })
            .then(response => response.json())
            .then((responseJson) => {
                if (responseJson.result.lenght !== 0) {
                    responseJson.result.map(function (val, i) {
                        arr.push(
                            <option value={val.name}>{val.name}</option>
                        )
                    }, this)
                    resolve(arr)
                } else {
                    resolve(0)
                }
            })
    })

    get_option_color = async () => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/bom_option_color'
        let arr = []
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify()
        })
            .then(response => response.json())
            .then((responseJson) => {
                if (responseJson.result.lenght !== 0) {
                    responseJson.result.map(function (val, i) {
                        arr.push(
                            <option value={val.name}>{val.name}</option>
                        )
                    }, this)
                    resolve(arr)
                } else {
                    resolve(0)
                }
            })
    })

    get_option_type = async () => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/bom_option_type'
        let arr = []
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify()
        })
            .then(response => response.json())
            .then((responseJson) => {
                if (responseJson.result.lenght !== 0) {
                    responseJson.result.map(function (val, i) {
                        arr.push(
                            <option value={val.name}>{val.name}</option>
                        )
                    }, this)
                    resolve(arr)
                } else {
                    resolve(0)
                }
            })
    })

    hideItem = (id) => {
        if (window.confirm('กรุณายืนยันการลบ Item')) {
            this.setState({ isLoading: true, onPage: 'Preview' })
            let arr = []
            let url = proxy.server + '/flim/hideItem'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify({ id: id })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    if (responseJson.status === 201) {
                        this.getItem()
                    } else {
                        alert('ไม่สามารถลบitemได้ กรุณาลองอีกครั้ง')
                    }
                })
        }
    }

    getSelectItem = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        let arroption_item = []
        let arroption_name = []
        let url = proxy.server + '/flim/getItem_forCreateBom'

        let dataWhere = {
            Item: '',
            Name: '',
        }

        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                // console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arroption_item.push(
                        { value: val.ItemId, label: val.ItemId }
                    )
                    arroption_name.push(
                        { value: val.SearchName, label: val.SearchName }
                    )
                }, this)

                this.setState({
                    option_Item: arroption_item,
                    option_Name: arroption_name
                }, () => {
                    //this.getItem()
                })
            })
    }

    allData_Preveiw = () => {
        this.setState({ Item: '', Name: '' }, () => {
            this.getItem()
        })
    }

    getItem = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        const { Item, Name } = this.state
        let arr = []
        let dataWhere = {
            Item: Item,
            Name: Name,
        }

        let url = proxy.server + '/flim/getItem_forCreateBom'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                arr = responseJson.result.map(function (val, i) {
                    return (<tr key={val.ItemId + val.db_name}>
                        <td style={{ justifyContent: 'center' }}>
                            <bs4.Button size="sm" color="danger" onClick={() => this.hideItem(val.id)}>DEL</bs4.Button>
                        </td>
                        <td style={{ justifyContent: 'center' }}>
                            <bs4.Col>
                                <bs4.Input type="checkbox" style={{ width: 23, height: 23, marginLeft: 10 }}
                                    onChange={(e) => this.checkItem(e.target.checked, val.id,
                                        val.ItemId, val.SearchName, val.ECL_ItemCategoryIdBrand1, val.ECL_ItemCategoryIdG3,
                                        val.grossWidth, val.grossHeight, val.ItemGroupId, val.db_name, val.BOMUnitId)} />
                            </bs4.Col>
                        </td>
                        {
                            val.db_name === 'DPL' ?
                                <td style={{ backgroundColor: '#00BFFF', color: '#000' }}>{val.db_name}</td>
                                : val.db_name === 'DFIX' ?
                                    <td style={{ backgroundColor: '#00FA9A', color: '#000' }}>{val.db_name}</td>
                                    : val.db_name === 'DPT' ?
                                        <td style={{ backgroundColor: '#fec23e', color: '#000' }}>{val.db_name}</td>
                                        : ''
                        }
                        <td>{val.ItemId}</td>
                        <td>{val.SearchName}</td>
                    </tr>)
                }, this)

                this.setState({ optionItem: arr, isLoading: false })
            })
    }

    checkItem = (check, id, itemName, description, ibrand1, itemG3, grossWidth, grossHeight, itemGroup, db_name, bomUnitId) => {
        let data = {}
        let G3 = itemG3.split(' ')
        let value = '%'
        G3.map((val, i) => {
            if (i + 1 == G3.length) {
                value += val
            } else {
                value += val + '_'
            }
        })

        console.log('checkItem', value)

        if (check === true) {
            data = {
                id: id,
                item_no: itemName,
                item_description: description,
                bom_no: itemName,
                bom_description: description,
                ibrand1: ibrand1,
                itemG3: itemG3,
                G3: value,
                grossWidth: grossWidth,
                grossHeight: grossHeight,
                item_group: itemGroup,
                db_name: db_name,
                size: '',
                front_back: '',
                type: '',
                color: '',
                bomSm1: '',
                bomSm2: '',
                bomQty: '',
                bomUnitId: '',
                user: localStorage.getItem("ID_User")
            }
            let arr = this.state.arr_temp_item.concat(data)
            this.setState({
                arr_temp_item: arr
            }, () => {
                // console.log('arr_temp_item', this.state.arr_temp_item)
            })
        } else {
            let arr = this.state.arr_temp_item

            for (var i = arr.length; i--;) {
                if (arr[i].id === id) arr.splice(i, 1);
            }
            this.setState({
                arr_temp_item: arr
            }, () => {
                // console.log('arr_temp_item', this.state.arr_temp_item)
            })
        }
    }

    addItem = () => {
        this.setState({
            arr_save: this.state.arr_temp_item
        }, () => {
            this.showItem()
        })
    }

    showItem = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        let arr = []

        arr = this.state.arr_save.map(function (val, i) {
            return (
                <tr style={{ textAlign: 'center' }} key={val.item_no + val.db_name}>
                    <td style={{ width: 40 }}><bs4.Button size='sm' color='danger' onClick={(e) => this.onDelete(i)}>DEL</bs4.Button></td>
                    <td>{val.item_no}</td>
                    <td>{val.item_description}</td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 250 }}>
                            <bs4.Input type="text" name="bom_no" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.bom_no} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 250 }}>
                            <bs4.Input type="textarea" name="bom_description" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.bom_description} />
                        </bs4.Col>
                    </td>
                    <td>{val.ibrand1}</td>
                    <td>{val.itemG3}</td>
                    <td>{val.grossWidth}</td>
                    <td>{val.grossHeight}</td>
                    <td>{val.item_group}</td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 170 }}>
                            <bs4.Input type="select" name="size" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value={''}>-----------</option>
                                {this.state.option_size}
                            </bs4.Input>
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 170 }}>
                            <bs4.Input type="select" name="front_back" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value={''}>-----------</option>
                                <option value='F'>F</option>
                                <option value='F+B'>F+B</option>
                            </bs4.Input>
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 170 }}>
                            <bs4.Input type="select" name="type" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value={''}>-----------</option>
                                {this.state.option_type}
                            </bs4.Input>
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 170 }}>
                            <bs4.Input type="select" name="color" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value={''}>-----------</option>
                                {this.state.option_color}
                            </bs4.Input>
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 250 }}>
                            {
                                val.item_no.substr(0, 3) === 'S05' || val.item_no.substr(0, 3) === 'T0A' || val.item_no.substr(0, 3) === 'TAB'
                                    ? <Select className="col-md-12"
                                        onChange={(e) => this.setState({ selectedOption: e.value }, () => this.handleChangeItem(i, "bomSm1", e.value))}
                                        options={this.state.option_roll}
                                        placeholder={'Bom SM 1'}
                                    />
                                    : <bs4.Input type="text" name="bomSm1" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                            }
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 250 }}>
                            {
                                val.item_no.substr(0, 3) === 'S05' || val.item_no.substr(0, 3) === 'T0A' || val.item_no.substr(0, 3) === 'TAB'
                                    ? <Select className="col-md-12"
                                        onChange={(e) => this.setState({ selectedOption: e.value }, () => this.handleChangeItem(i, "bomSm2", e.value))}
                                        options={this.state.option_roll}
                                        placeholder={'Bom SM 2'}
                                    />
                                    : <bs4.Input type="text" name="bomSm2" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                            }
                        </bs4.Col>
                    </td>
                    <td>{val.bomQty}</td>
                    <td>{val.bomUnitId}</td>
                </tr>
            )
        }, this)

        this.setState({ showItem: arr, isLoading: false })
    }

    handleChangeItem = async (index, name, value) => {
        if (name === 'bom_no') {
            this.state.arr_save[index].bom_no = value
        } else if (name === 'bom_description') {
            this.state.arr_save[index].bom_description = value
        } else if (name === 'size') {
            this.state.arr_save[index].size = value
        } else if (name === 'front_back') {
            this.state.arr_save[index].front_back = value
        } else if (name === 'type') {
            this.state.arr_save[index].type = value
        } else if (name === 'color') {
            this.state.arr_save[index].color = value
        } else if (name === 'bomSm1') {
            let dataStandrad = await this.get_dataStandrad(value.substr(0, 3))
            let bomSm1_description = await this.selectDescriptionSM(value)

            this.state.arr_save[index].bomSm1 = value
            this.state.arr_save[index].bomSm1_description = bomSm1_description
            this.state.arr_save[index].bomUnitId = dataStandrad === undefined || dataStandrad.InventTableModuleInvent_UnitId === null ? '' : dataStandrad.InventTableModuleInvent_UnitId

            let qty
            let twodigit = value.substr(0, 2)
            let width = this.state.arr_save[index].grossWidth
            let height = this.state.arr_save[index].grossHeight
            let area = width * (height + 0.5)

            if (twodigit === 'RT') {
                qty = area / 10000
            } else if (twodigit === 'RA' || twodigit === 'RF') {
                let min = await this.get_bommin(value)
                qty = area * min
            } else {
                qty = 1
            }

            // console.log('qty', qty)
            this.state.arr_save[index].bomQty = qty.toFixed(2)
        } else if (name === 'bomSm2') {
            let bomSm2_description = await this.selectDescriptionSM(value)
            this.state.arr_save[index].bomSm2 = value
            this.state.arr_save[index].bomSm2_description = bomSm2_description
        }

        this.setState({
            arr_save: this.state.arr_save
        }, () => {
            // console.log('arr_save', this.state.arr_save)
            this.showItem()
        })
    }


    get_dataStandrad = async (itemG1) => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/get_dataStandrad'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                itemG1: itemG1,
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                // console.log("get_dataStandrad", responseJson.result[0])
                if (responseJson.result.lenght !== []) {
                    resolve(responseJson.result[0])
                } else {
                    resolve(0)
                }
            })
    })

    get_bommin = async (_slit) => new Promise((resolve, reject) => {
        this.setState({ isLoading: true })
        let url = proxy.server + '/flim/get_bommin'
        let arr = []
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                slit: _slit
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log('result', responseJson.result[0])
                if (responseJson.result[0] !== undefined) {
                    this.setState({ isLoading: false })
                    resolve(responseJson.result[0].cm2)
                } else {
                    this.setState({ isLoading: false })
                    resolve(0)
                }
            })
    })

    onDelete = (i) => {
        this.state.arr_save.splice(i, 1)
        this.setState({
            arr_save: this.state.arr_save,
        }, () => {
            // console.log('item_tamp', this.state.item_tamp)
            this.showItem()
        })
    }

    setBomline = (myarr) => new Promise(async (resolve, reject) => {
        let arr_BomLine = []
        let arrResult = []

        let url = proxy.server + '/flim/selectDataBomLine'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                arr: myarr
            })
        })
            .then(response => response.json())
            .then(async (responseJson) => {
                //console.log('responseJson', responseJson.result)
                resolve(responseJson.result)
            })
    })

    selectDescriptionSM = (item) => new Promise(async (resolve, reject) => {
        let url = proxy.server + '/flim/selectDescriptionSM'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                item: item
            })
        })
            .then(response => response.json())
            .then(async (responseJson) => {
                console.log('responseJson', responseJson)
                if (responseJson.status === 304) {
                    resolve('')
                } else {
                    resolve(responseJson.result[0].NAMEALIAS)
                }
            })
    })

    getDataBomLine = async () => {
        this.setState({ isLoading: true })
        let myarr = []
        let arrID = []

        this.state.arr_save.map(async function (val, i) {
            console.log('arr_save', val)

            arrID.push(val.id)
            myarr.push({
                ibrand1: val.ibrand1,
                G3: val.G3,
                size: val.size,
                front_back: val.front_back,
                type: val.type,
                color: val.color,
                item_no: val.item_no,
                item_description: val.item_description,
                bomSm1: val.bomSm1,
                bomSm1_description: val.bomSm1_description,
                bomSm2: val.bomSm2,
                bomSm2_description: val.bomSm2_description,
                unitId: val.bomUnitId,
                item_group: val.item_group,
                user: val.user,
                db_name: val.db_name,
                bomQty: val.bomQty
            })
        })

        let arr_BomLine = await this.setBomline(myarr)
        console.log('arr_BomLine3', arr_BomLine)

        this.setState({ arrID: arrID, arr_saveBomLine: arr_BomLine }, () => {
            this.saveBomVersion()
        })
    }

    saveBomVersion = () => {
        // console.log('arr_save', this.state.arr_save)
        // this.saveBomLine()
        console.log('arr_saveBomLine', this.state.arr_saveBomLine)
        if (window.confirm("กรุณายืนยันการบันทึก")) {
            this.setState({ isLoading: true })

            let url = proxy.server + '/flim/insert_bomVersion'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify(this.state.arr_save)
            })
                .then(response => response.json())
                .then((responseJson) => {
                    // console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.saveBomLine()
                    } else {
                        alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                        // this.reload()
                    }
                })
        }
    }

    saveBomLine = () => {
        this.setState({ isLoading: true })
        console.log('arr_saveBomLine', this.state.arr_saveBomLine)

        let url = proxy.server + '/flim/insert_bomLine'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                arrBomLine: this.state.arr_saveBomLine,
                arrID: this.state.arrID
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                // console.log("responseJson", responseJson)
                if (responseJson.status === 201) {
                    this.setState({ isLoading: false }, () => {
                        this.reload()
                    })
                } else {
                    alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                    //this.reload()
                }
            })
    }

    reload = () => {
        window.location.reload()
    }

    render() {
        return <div>
            <Navbar nav={'Flim'} menu={'Flim_CreateBomVer'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>Item</bs4.Label>
                    <bs4.Col sm='4'>
                        <Select className="col-md-12"
                            onChange={(e) => this.setState({ Item: e.value })}
                            options={this.state.option_Item}
                            placeholder={'ค้นหา Item'}
                        />
                    </bs4.Col>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>Name</bs4.Label>
                    <bs4.Col sm='4'>
                        <Select className="col-md-12"
                            onChange={(e) => this.setState({ Name: e.value })}
                            options={this.state.option_Name}
                            placeholder={'ค้นหา Name'}
                        />
                    </bs4.Col>
                    <bs4.Button outline color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.getItem()}>SEARCH</bs4.Button>
                    <bs4.Button outline style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.allData_Preveiw()}>ดู Item ทั้งหมด</bs4.Button>
                </bs4.FormGroup>
                <bs4.FormGroup row>
                    <bs4.Label style={{ fontSize: 18, marginLeft: 20, marginRight: 10 }}>เลือก Item เพื่อสร้าง Bom : </bs4.Label>
                    <Scrollbars style={{ width: 1300, height: 280 }}>
                        <bs4.Table size='sm' bordered hover>
                            <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                                <tr style={{ textAlign: 'center' }}>
                                    <th></th>
                                    <th></th>
                                    <th>ฐานข้อมูล</th>
                                    <th style={{ backgroundColor: '#61ba52', color: '#000' }}>Item</th>
                                    <th style={{ backgroundColor: '#61ba52', color: '#000' }}>Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.optionItem}
                            </tbody>
                        </bs4.Table>
                    </Scrollbars>
                </bs4.FormGroup>
                <br />
                <bs4.FormGroup row style={{ marginLeft: 10, marginRight: 10 }}>
                    {this.state.arr_temp_item.length === 0
                        ? <bs4.Button color="warning" style={{ marginBottom: 10, fontWeight: 500 }} disabled>+ ADD BOM VERSION</bs4.Button>
                        : <bs4.Button color="warning" style={{ marginBottom: 10, fontWeight: 500 }} onClick={() => this.addItem()}>+ ADD BOM VERSION</bs4.Button>
                    }
                    {this.state.arr_save.length === 0
                        ? <bs4.Button color="success" style={{ marginLeft: 10, marginBottom: 10, fontWeight: 500, marginRight: 10 }} disabled>SAVE BOM</bs4.Button>
                        : <bs4.Button color="success" style={{ marginLeft: 10, marginBottom: 10, fontWeight: 500, marginRight: 10 }} onClick={() => this.getDataBomLine()}>SAVE BOM</bs4.Button>
                    }

                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>
                <bs4.Table bordered hover>
                    <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            <th></th>
                            <th>Item</th>
                            <th>Name</th>
                            <th style={{ backgroundColor: '#61ba52', color: '#000' }}>Bom Code</th>
                            <th style={{ backgroundColor: '#61ba52', color: '#000' }}>Bom Name</th>
                            <th style={{ backgroundColor: '#61ba52', color: '#000' }}>Ibrand1</th>
                            <th style={{ backgroundColor: '#61ba52', color: '#000' }}>ItemG3</th>
                            <th style={{ backgroundColor: '#61ba52', color: '#000' }}>กว้าง</th>
                            <th style={{ backgroundColor: '#61ba52', color: '#000' }}>ยาว</th>
                            <th style={{ backgroundColor: '#61ba52', color: '#000' }}>ItemGroupId</th>
                            <th>Size</th>
                            <th>หน้า-หลัง</th>
                            <th>Type</th>
                            <th>Color</th>
                            <th>Bom SM 1</th>
                            <th>Bom SM 2 <font style={{ color: 'red' }}>(ถ้ามี)</font></th>
                            <th style={{ backgroundColor: '#61ba52', color: '#000' }}>BOMQty</th>
                            <th style={{ backgroundColor: '#61ba52', color: '#000' }}>UnitId</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.showItem}
                    </tbody>
                </bs4.Table>
            </div>
        </div>
    }
}

export default Flim_CreateBomVer